import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvatarControlComponent } from './avatar-control.component';

@NgModule({
  declarations: [AvatarControlComponent],
  imports: [CommonModule],
  exports: [AvatarControlComponent]
})
export class AvatarControlModule {}
